import router from "./router/router";
import "./blocks/layout/body";
import "./blocks/layout/header";
import "./blocks/index/pulots";

router();

const appHeight = () => {
  document.documentElement.style.setProperty(
    "--app-height",
    `${window.innerHeight}px`
  );
};

window.addEventListener("resize", appHeight);
appHeight();
